export default "__VITE_ASSET__KSqwXdh4__"